const STYLES = {
  online: { label: "En ligne", cls: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30", dot: "bg-emerald-400 shadow-[0_0_8px_#34d399]" },
  offline: { label: "Hors ligne", cls: "bg-amber-500/15 text-amber-400 border-amber-500/30", dot: "bg-amber-400" },
  revoked: { label: "Révoqué", cls: "bg-rose-500/15 text-rose-400 border-rose-500/30", dot: "bg-rose-400" },
  never: { label: "Jamais connecté", cls: "bg-cyan-500/15 text-cyan-400 border-cyan-500/30", dot: "bg-cyan-400 animate-pulse" },
};

export function screenState(s: { status: string; online: boolean; last_seen_at: string | null }): keyof typeof STYLES {
  if (s.status === "revoked") return "revoked";
  if (!s.last_seen_at) return "never";
  return s.online ? "online" : "offline";
}

export function StatusPill({ state, testId }: { state: keyof typeof STYLES; testId?: string }) {
  const st = STYLES[state];
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wider ${st.cls}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${st.dot}`} />
      {st.label}
    </span>
  );
}
